import React, { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { Box, Typography, Container, Grid, CardMedia } from '@mui/material'
import { motion } from 'framer-motion'
import './AboutUs.css'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default function WhyChooseUsPage() {
  type GroupTextItem = {
    id: number
    h1: string
    small_txt: string
    icon: {
      url: string
      width?: number
      height?: number
      alternativeText?: string
    }
  }

  const [sub_txt, setSub_txt] = useState<string>('')
  const [mainText, setMainText] = useState<string>('Loading...')
  const [whyUs, setWhyUs] = useState<string>('Loading...')
  const [content, setCont] = useState<string>('')
  const [whyUs2, setWhyUs2] = useState<string>('')
  const [content2, setCont2] = useState<string>('')
  const [groupText, setGroupText] = useState<GroupTextItem[]>([])
  const BASE_URL = 'https://app.dfopsa.online'

  const leftRef = useRef<HTMLDivElement>(null)
  const rightRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          'https://app.dfopsa.online/api/technology?populate[technology][populate]=*'
        )

        const sub_txt = res?.data?.data?.sub_txt
          ? `${res?.data?.data?.sub_txt}`
          : ''

        const mainText = res?.data?.data?.h1
          ? `${res?.data?.data?.h1}`
          : 'Loading...'

        const groupTextData = res?.data?.data?.technology || []

        setSub_txt(sub_txt)
        setMainText(mainText)
        setGroupText(groupTextData)
      } catch (error) {
        console.error('Failed to fetch statistic data:', error)
      }
    }

    const fetchData2 = async () => {
      try {
        const res = await axios.get('https://app.dfopsa.online/api/about-us')

        const mainText = res?.data?.data?.h1
          ? `${res?.data?.data?.h1}`
          : 'Loading...'

        const content_1 = res?.data?.data?.content_1
          ? `${res?.data?.data?.content_1}`
          : ''

        const mainText2 = res?.data?.data?.h2 ? `${res?.data?.data?.h2}` : ''

        const content_2 = res?.data?.data?.content_2
          ? `${res?.data?.data?.content_2}`
          : ''

        setWhyUs(mainText)
        setCont(content_1)
        setWhyUs2(mainText2)
        setCont2(content_2)
      } catch (error) {
        console.error('Failed to fetch statistic data2:', error)
      }
    }

    fetchData()
    fetchData2()
  }, [])

  useEffect(() => {
    if (leftRef.current) {
      gsap.fromTo(
        leftRef.current,
        { opacity: 0, x: -100 },
        {
          opacity: 1,
          x: 0,
          duration: 0.8,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: leftRef.current,
            start: 'top 80%',
            toggleActions: 'play none none reverse',
          },
        }
      )
    }
    if (rightRef.current) {
      gsap.fromTo(
        rightRef.current,
        { opacity: 0, x: 100 },
        {
          opacity: 1,
          x: 0,
          duration: 0.8,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: rightRef.current,
            start: 'top 80%',
            toggleActions: 'play none none reverse',
          },
        }
      )
    }
  }, [whyUs, content, whyUs2, content2])

  return (
    <Box className='why_chose'>
      <Container className='why_chose' maxWidth='lg' sx={{ pb: 0 }}>
        <Grid container spacing={10} alignItems='center'>
          <Grid item xs={12} md={6} mt={-15}>
            <Box ref={leftRef}>
              <CardMedia
                sx={{ maxHeight: '300px', objectFit: 'contain' }}
                component='img'
                image='https://www.playtech.com/app/uploads/2023/01/Casino-Games-Animation-1.svg'
                alt='Slideshows'
                className='imageCard'
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box ref={rightRef}>
              <Typography
                sx={{ fontSize: { xs: 28, md: 34 } }}
                variant='h4'
                fontWeight='bold'
                gutterBottom
              >
                {whyUs}
              </Typography>
              <Typography paragraph>{content}</Typography>
              <Typography
                sx={{ fontSize: { xs: 20, md: 24 } }}
                variant='h5'
                fontWeight='bold'
                gutterBottom
              >
                {whyUs2}
              </Typography>
              <Typography>{content2}</Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Box className='why_chose' sx={{ py: 10 }}>
        <Container maxWidth='lg' sx={{ mb: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography
                className='bodyone'
                variant='h6'
                fontWeight='bold'
                gutterBottom
                sx={{ mt: 5 }}
              >
                {sub_txt}
              </Typography>
              <Typography
                sx={{ fontWeight: 700, fontSize: { xs: 30, md: 35 } }}
                variant='h3'
                className='bodynext'
              >
                {mainText}
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}></Grid>
          </Grid>
          <Grid container spacing={4} sx={{ mt: { xs: 0, md: 6 } }}>
            {groupText.map((feature, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.6, ease: 'easeOut' }}
                >
                  {feature?.icon && (
                    <img
                      src={`https://app.dfopsa.online${feature?.icon?.url}`}
                      alt='Feature Icon'
                      width={40}
                      height={40}
                    />
                  )}
                  <Box display='flex' alignItems='flex-start' gap={1}>
                    <Box>
                      <Typography fontWeight='bold'>{feature.h1}</Typography>
                      <Typography variant='body2'>
                        {feature.small_txt}
                      </Typography>
                    </Box>
                  </Box>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Box>
  )
}
